// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3aQAh","productName":"Table_productName__347G0"};